import React, { Fragment, useState } from "react";
import { useSelector } from "react-redux";
import { Grid, Typography, styled } from "@mui/material";

import EditRoundedIcon from "@mui/icons-material/EditRounded";

import ButtonBlue from "../../shared/general/ButtonBlue";
import DividerStyle from "../../shared/general/Divider";

import Signature from "../../assets/signature.png";

import DialogEdit from "./DialogEdit";

const StyledRoot = styled("div")({
  "& .signature": {
    height: 100,
  },
});

const StyledHeadLabel = styled(Typography)({
  fontWeight: 600,
  fontSize: 14,
});

const StyledWrapTop = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 16,
  "&.inner": {
    marginBottom: 0,
  },
  "& .MuiTypography-body2": {
    margin: 0,
  },
});

const TabCompany = (props) => {
  const { result: companyProfile } = useSelector(
    (state) => state.companyProfile
  );

  const [openDialog, setOpenDialog] = useState(false);
  const [mode, setMode] = useState(null);

  const handleClick = (mode) => {
    setOpenDialog(true);
    setMode(mode);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <StyledRoot>
      <StyledWrapTop>
        <Typography variant="body2" style={{ fontWeight: 600 }}>
          ข้่อมูลทั่วไป
        </Typography>
        <ButtonBlue
          size="small"
          startIcon={<EditRoundedIcon />}
          onClick={() => handleClick("general")}
        >
          แก้ไข
        </ButtonBlue>
      </StyledWrapTop>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <StyledHeadLabel color="text.secondary">รหัสบริษัท</StyledHeadLabel>
          <Typography variant="h6">
            {companyProfile.companyCode || "-"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <StyledHeadLabel color="text.secondary">
            Social Security A/C
          </StyledHeadLabel>
          <Typography variant="h6">
            {companyProfile.socialSecurityAccount || "-"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <StyledHeadLabel color="text.secondary">
            Provident Fund Code
          </StyledHeadLabel>
          <Typography variant="h6">
            {companyProfile.providentFundCode || "-"}
          </Typography>
        </Grid>
      </Grid>
      <DividerStyle />
      <StyledWrapTop>
        <Typography variant="body2" style={{ fontWeight: 600 }}>
          การติดต่อ
        </Typography>
        <ButtonBlue
          size="small"
          startIcon={<EditRoundedIcon />}
          onClick={() => handleClick("contact")}
        >
          แก้ไข
        </ButtonBlue>
      </StyledWrapTop>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <StyledHeadLabel color="text.secondary">
            เบอร์โทรศัพท์บริษัท
          </StyledHeadLabel>
          <Typography variant="h6">
            {companyProfile.companyTelephone || "-"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <StyledHeadLabel color="text.secondary">Email บริษัท</StyledHeadLabel>
          <Typography variant="h6">
            {companyProfile.companyEmail || "-"}
          </Typography>
        </Grid>
      </Grid>
      <DividerStyle />
      <StyledWrapTop>
        <Typography variant="body2" style={{ fontWeight: 600 }}>
          ผู้มีอำนาจลงนาม
        </Typography>
        <ButtonBlue
          size="small"
          startIcon={<EditRoundedIcon />}
          onClick={() => handleClick("authorized")}
        >
          แก้ไข
        </ButtonBlue>
      </StyledWrapTop>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <StyledHeadLabel color="text.secondary">ชื่อผู้มีอำนาจของบริษัท คนที่ 1</StyledHeadLabel>
          <Typography variant="h6">
            {companyProfile.authorizedSignatureOneName || "-"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <StyledHeadLabel color="text.secondary">ตำแหน่งผู้มีอำนาจของบริษัท คนที่ 1</StyledHeadLabel>
          <Typography variant="h6">
            {companyProfile.authorizedSignatureOnePosition || "-"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <StyledHeadLabel color="text.secondary">ชื่อผู้มีอำนาจของบริษัท คนที่ 2</StyledHeadLabel>
          <Typography variant="h6">
            {companyProfile.authorizedSignatureTwoName || "-"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <StyledHeadLabel color="text.secondary">ตำแหน่งผู้มีอำนาจของบริษัท คนที่ 2</StyledHeadLabel>
          <Typography variant="h6">
            {companyProfile.authorizedSignatureTwoPosition || "-"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <StyledHeadLabel color="text.secondary">ชื่อพยาน</StyledHeadLabel>
          <Typography variant="h6">
            {companyProfile.witnessSignatureName || "-"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <StyledHeadLabel color="text.secondary">ตำแหน่งพยาน</StyledHeadLabel>
          <Typography variant="h6">
            {companyProfile.witnessSignaturePosition || "-"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <StyledHeadLabel color="text.secondary">ชื่อผู้ออกหนังสือรับรอง</StyledHeadLabel>
          <Typography variant="h6">
            {companyProfile.certificateSignatureName || "-"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <StyledHeadLabel color="text.secondary">ตำแหน่งผู้ออกหนังสือรับรอง</StyledHeadLabel>
          <Typography variant="h6">
            {companyProfile.certificateSignaturePosition || "-"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <StyledHeadLabel color="text.secondary">ชื่อผู้ออกหนังสือรับรอง(อังกฤษ)</StyledHeadLabel>
          <Typography variant="h6">
            {companyProfile.certificateSignatureName_EN || "-"}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <StyledHeadLabel color="text.secondary">ตำแหน่งผู้ออกหนังสือรับรอง(อังกฤษ)</StyledHeadLabel>
          <Typography variant="h6">
            {companyProfile.certificateSignaturePosition_EN || "-"}
          </Typography>
        </Grid>
        {/* <Grid item xs={12} sm={6}>
          <StyledHeadLabel color="text.secondary" gutterBottom>
            ลายเซ็นต์
          </StyledHeadLabel>
          <img src={Signature} className="signature" />
        </Grid> */}
      </Grid>

      <DialogEdit
        mode={mode}
        open={openDialog}
        handleCloseDialog={handleCloseDialog}
      />
    </StyledRoot>
  );
};

export default TabCompany;
